import React from 'react';
import { Button, Card, Col, Form, Icon, Input, message, Modal, Popover, Row, Select, Tooltip } from 'antd';
import { fetchEvt } from "../../redux/actions/evt";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { inEditMode } from "../../redux/actions/global";
import { updateEventPosters } from "../../services/evt";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import QRCode from "../../components/qr-code/QRCode";
import Logo2 from "../../style/imgs/logo2.png"
import canvasToImage from 'canvas-to-image';
import { disableCheckinpoint, enableCheckinpoint } from "../../services/checkinpoint";
import classnames from "classnames";
import moment from 'moment';
import CkUpload from "../../components/CkUpload";
import { batchConfigureIbeacon, findUserIbeacons, findIbeacons } from "../../services/ibeaconConfig";
import styled from "styled-components";
import config from '../../utils/config'
import EvtViewCheckinpointDes from "./EvtViewCheckinpointDes";
import EvtViewCheckinpointPeriodicTime from "./EvtViewCheckinpointPeriodicTime";
import EvtViewCheckinpointSubAccount from "./EvtViewCheckinpointSubAccount";
import PurchaseServiceTips from "../PurchaseServiceTips";
import { isValidity ,isSubAccount } from "../../services/global";
import {mobile_url_domin} from "../../utils/config";

const mapStateToPorps = state => {
    const loginedUser = state.loginedUser;
    const cmEnums = state.cmEnums;
    return { cmEnums, loginedUser };
};
const mapDispatchToProps = dispatch => ({
    fetchEvt: bindActionCreators(fetchEvt, dispatch),
});



const IbeanconOptionContent = styled.div`
  display: flex;
  min-width: 430px;
  .ibeancons-icon{
    img{
      width: 60px;
      height: 60px;
    }
    margin-right: 7px;
  }
  .ibeancons-configured-desc{
      color: #999;
      font-size: 12px;
  }
  .ibeancons-id{
  
  }
  .ibeancons-configured-status{
    .used-status{
        color: #f5222d;
    }
    .noused-status{
       color: #52c41a
    }
  }

`

const IbeanconSelect = styled(Select)`
  .ant-select-selection__choice__content .ibeancons-icon{
    img{
      width: 24px;
      height: 24px;
    }
  }
`

class EvtViewCheckinpointQrcode extends React.Component {
    constructor(props) {
        super(props);
        this.mounted = false;
        this.pstView = null;
        this.state = {
            isMember: 'SENIORMEMBER',
            validity: false,
            validityCheckinTiming: false,
            editCheckinpointVisible: false,
            editCheckinpointTimeVisible: false,
            editCheckinpointSubAccVisible: false,
            checkinpointDes: null,
            qrcodeSize: [{ px: 258, side: 8, dis: 0.5 }, { px: 344, side: 12, dis: 0.8 }, { px: 430, side: 15, dis: 1.0 }, { px: 860, side: 30, dis: 1.5 }, { px: 1280, side: 50, dis: 2.5 }],
            qrcodeModal: {
                title: null,
                refName: null,
                value: null
            },
            qrcodeDownload: false,
            formLoading: false,
            ibeanconConfigModalVisible: false,
            viewCheckinpoint: null,
            viewCheckinpointBoundIbeacons: null,
            ibeancons: [],
        }
    }


    componentDidMount() {
        this.mounted = true;

    }

    componentWillUnmount() {
        this.mounted = false;
    }


    changeFormLoading = (loading) => {
        if (this.mounted) {
            this.setState({
                formLoading: loading,
            })
        }
    }

    handleCancel = () => {
        this.changeFormLoading(false);
        this.setState({
            ibeanconConfigModalVisible: false,
            viewCheckinpointBoundIbeacons: null,
            viewCheckinpoint: null,
        })
        this.props.editableChange(this.props.editableStatePropName, false)
    }

    downloadQR = (QRRef, fileName) => {
        canvasToImage(QRRef, {
            name: fileName,
            type: 'png',
            quality: 1
        });
    }

    showQrcodeDownload = (obj, index) => {
        const { evt } = this.props;
        let _obj = {
            title: `签到二维码（${obj.name}）`,
            refName: `checkinpoint-qr-canvas${index}`,
            value: `${mobile_url_domin}/mobile/checkin?eventId=${evt.header.id}&checkinPointId=${obj.id}&hostUserId=${localStorage.getItem('userId')}`
        };
        this.setState({
            qrcodeModal: _obj,
        }, () => {
            this.setState({
                qrcodeDownload: true,
            })
        })
    }
    handQrcodeDownload = () => {
        this.setState({
            qrcodeDownload: false,
        })
    }

    showCheckinpointModal = (record) => {
        this.setState({
            checkinpointDes: record,
        }, () => this.setState({ editCheckinpointVisible: true }))
    }


    render() {
        const evt = this.props.evt;

        console.log(" this.props.evt", this.props.evt);


        const formItemLayout = {
            labelCol: {
                xs: { span: 6 },
                sm: { span: 6 },
            },
            wrapperCol: {
                xs: { span: 18 },
                sm: { span: 18 },
            },
        };

        return (
            <div>
                <Row gutter={16} className="checkinpoint-comp">
                    {evt.checkinpoints.map((checkinpoint, index) => {

                        const ckpBeginTime = checkinpoint.beginTime ? moment(checkinpoint.beginTime, "YYYY-MM-DD HH:mm:ss") : null;
                        const ckpEndTime = checkinpoint.endTime ? moment(checkinpoint.endTime, "YYYY-MM-DD HH:mm:ss") : null;

                        const qrcode = <QRCode
                            value={`${mobile_url_domin}/mobile/checkin?eventId=${evt.header.id}&checkinPointId=${checkinpoint.id}&hostUserId=${localStorage.getItem('userId')}`}
                            size={150}
                            logoWidth={35}
                            logoHeight={35}
                            refName={`checkinpoint-qr-canvas${index}`}
                            logo={evt.header.customQrcodeLogo ? evt.header.customQrcodeLogo : "https://img.qdj8.cn/4db620938b1bbe99aff190c611092df9f63e0e89.jpg"} />



                        return (
                            <Col span={12} className='checkinpoint-item' key={`checkinpoint-qr-${index}`}>
                                <Card
                                    bordered={true}
                                    title={
                                        <div>
                                            {/*<div className="checkinpoint-qrcode-tl">*/}
                                            <div className="checkinpoint-qrcode-tl">
                                            
                                                <span style={{ fontSize: "12px", cursor: "pointer" }}
                                                    /*className="checkinpoint-qrcode-open-or-close-btn">*/
                                                    className="">
                                                    {
                                                        checkinpoint.active ? "签到点开启中" : "签到点已关闭"
                                                    }
                                                </span>


                                            </div>
                                            <div className="checkinpoint-qrcode-ckname">{checkinpoint.name}<span style={{ color: '#959595' }}>{checkinpoint.enableCheckinTiming && '（周期性签到）'}</span></div>


                                            <div className="checkinpoint-qrcode-2row">
                                                <div className="checkinpoint-qrcode-time">
                                                    {
                                                        ckpBeginTime || ckpEndTime ?
                                                            `${ckpBeginTime ? ckpBeginTime.format("YYYY-MM-DD HH:mm:ss") : '不限签到开始日期'} ~ ${ckpEndTime ? ckpEndTime.format("YYYY-MM-DD HH:mm:ss") : '不限签到结束日期'}`
                                                            :
                                                            "不限制签到日期"
                                                    }

                                                </div>
                                                {/*<div className="checkinpoint-qrcode-ckcount">*/}
                                                {/*{checkinpoint.address && <span className='ckname-address'>*/}
                                                {/*<Tooltip overlayClassName='overlay-image' mouseEnterDelay={0.3} title={*/}
                                                {/*<span>{checkinpoint.address}</span>*/}
                                                {/*}>*/}
                                                {/*<span>{checkinpoint.address}</span>*/}
                                                {/*</Tooltip>*/}
                                                {/*</span>}*/}
                                                {/*<a className='ckname-addressicon' href="#" onClick={()=>{*/}
                                                {/*this.showCheckinpointModal(checkinpoint);*/}
                                                {/*}}>*/}
                                                {/*<Icon style={{fontSize:16}} type={'environment'}/>*/}
                                                {/*<span>定位</span>*/}
                                                {/*<Tooltip  mouseEnterDelay={0.3} title={*/}
                                                {/*<div>*/}
                                                {/*<p>签到点可以开启定位签到，范围在设置地址（约500米内）。</p>*/}
                                                {/*<p>重要提示：开启定位后，如果参与人签到时定位失败或不在指定范围内，将无法签到。</p>*/}
                                                {/*</div>*/}


                                                {/*}>*/}
                                                {/*<span title="" style={{marginLeft: "3px"}}><Icon style={{color:'#434343'}} type="question-circle-o"/></span>*/}
                                                {/*</Tooltip>*/}
                                                {/*</a></div>*/}
                                            </div>

                                        </div>
                                    }
                                    className={classnames("qrcode-card", "checkinpoint-qrcode-card", { "checkinpoint-inactive": !checkinpoint.active })}>
                                    <div className="qrcode-card-contain" style={{ alignItems: 'flex-end' }}>
                                        <div className="qrcode-card-qr">
                                            {qrcode}
                                        </div>
                                        <div className="qrcode-card-des">
                                            {/*<div>参与者可通过扫描此二维码签到</div>*/}

                                            <div className="qrcode-tools">
                                                {
                                                    isSubAccount(this.props.loginedUser) &&
                                                <div className="qtd">
                                                    <div className="qtd-title">
                                                        扫码签到&nbsp;
                                                        <span>
                                                            
                                                        </span>：
                                                    </div>
                                                    <div className="qtd-content">
                                                        <a href={`/evt/${evt.header.id}/checkpoint/${checkinpoint.id}/organizer-scan-checkin`}
                                                            target="_blank">进入</a>
                                                    </div>
                                                </div>}
                                                <div className="qtd">
                                                    <div className="qtd-title">
                                                        动态签到码&nbsp;
                                                        <span>
                                                            <Tooltip placement="bottom" overlayClassName='overlay-image'
                                                                mouseEnterDelay={0.3} title={
                                                                    <div>
                                                                        防作弊，自动刷新二维码，可以防止拍照作弊，连接打印机后，可支持参与人扫码签到后自动打印胸牌。 <a href="https://www.kancloud.cn/seven_qdj/qdj_detail01/769881" target="_Blank" >  详细帮助</a>
                                                                    </div>
                                                                }>
                                                                <Icon type="question-circle-o" />
                                                            </Tooltip>
                                                        </span>：
                                                    </div>
                                                    <div className="qtd-content">
                                                        <a href={
                                                            isSubAccount(this.props.loginedUser) ?
                                                            `/sub/evtm/evt/${evt.header.id}/checkpoint/${checkinpoint.id}/dynamic-checkin-qrcode`
                                                            :
                                                            `/evt/${evt.header.id}/checkpoint/${checkinpoint.id}/dynamic-checkin-qrcode`}
                                                            target="_blank">进入</a>
                                                    </div>
                                                </div>
                                                <div className="qtd" style={{ marginBottom: "5px" }}>
                                                    <div className="qtd-title">
                                                        静态签到码<Tooltip placement="bottom" overlayClassName='overlay-image' mouseEnterDelay={0.3} title={
                                                            <div>
                                                                静态签到码，可以下载打印，也可以复制静态签到码链接配置在您公众号中。
                                                        </div>
                                                        }><span title="" style={{ marginLeft: "3px" }}><Icon type="question-circle-o" /></span>
                                                        </Tooltip>：
                                                    </div>
                                                    <div className="qtd-content">
                                                        <a onClick={() => this.showQrcodeDownload(checkinpoint, index)}>下载</a>
                                                    </div>
                                                </div>
                                                <div>
                                                    <CopyToClipboard
                                                        text={`${mobile_url_domin}/mobile/checkin?eventId=${evt.header.id}&checkinPointId=${checkinpoint.id}&hostUserId=${localStorage.getItem('userId')}`}
                                                        onCopy={() => message.success("已复制!")}>
                                                        <a href="#">静态签到码链接</a>
                                                    </CopyToClipboard>

                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </Card>
                            </Col>
                        )
                    })}
                </Row>


                <Modal
                    visible={this.state.qrcodeDownload}
                    title={<div>
                        {this.state.qrcodeModal.title}
                        <p style={{ fontSize: 12, color: '#959595' }}>若无法下载，请使用最新版谷歌Chrome浏览器</p>
                    </div>}
                    // width="650px"
                    maskClosable={false}
                    onCancel={this.handQrcodeDownload}
                    footer={null}
                >
                    <div>
                        {this.state.qrcodeDownload ? this.state.qrcodeSize.map((obj, index) => {
                            return <div key={index} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '5px 30px' }}>
                                <div>
                                    <div style={{ display: 'none' }}>
                                        <QRCode
                                            value={this.state.qrcodeModal.value}
                                            size={obj.px}
                                            refName={`${this.state.qrcodeModal.refName}${index}`}
                                            logoWidth={obj.px / 6}
                                            logoHeight={obj.px / 6}
                                            logo={evt.header.customQrcodeLogo ? evt.header.customQrcodeLogo : Logo2} />
                                    </div>
                                    <div style={{ width: 82, textAlign: 'center' }}>
                                        <Icon type='qrcode' style={{ fontSize: 40 }} />
                                        <div style={{ fontSize: 12, color: '#999' }}>{obj.px}x{obj.px}像素</div>
                                    </div>
                                </div>
                                <div>边长{obj.side}cm</div>
                                <div>扫码距离{obj.dis}m</div>
                                <a href="#" onClick={this.downloadQR.bind(this, `${this.state.qrcodeModal.refName}${index}`, `[${evt.header.name}]-${this.state.qrcodeModal.title}_${obj.px}`)}>下载</a>
                            </div>
                        }) : ''}
                    </div>

                </Modal>



                <PurchaseServiceTips
                    ref={(pst) => {
                        this.pstView = pst
                    }}
                    member={'SENIORMEMBER'}

                />
            </div>
        )
    }
}


EvtViewCheckinpointQrcode.contextTypes = {}

EvtViewCheckinpointQrcode.defaultProps = {
    evt: {},
    editable: false,
    editableStatePropName: "checkinpointQrcodeEditable",
    editableChange: (editable, dataChanged = false) => null,
}

EvtViewCheckinpointQrcode.propTypes = {}


export default connect(mapStateToPorps, mapDispatchToProps)(EvtViewCheckinpointQrcode);


// WEBPACK FOOTER //
// ./src/containers/evt/EvtViewCheckinpointQrcode.jsx